<template>
  <div class="period">
    <SsgMessagebox
      :titles="tabstatus==5?'选择合同公司':'选择部门'"
      width="720px"
      height="100%"
      @shut="shut"
      @sub="sub"
    >
      <div class="boxs">
        <div class="box">
          <div class="search">
            <el-input
              prefix-icon="el-icon-search"
              v-model.trim="searchval"
              style="width: 100%;"
              @change="onsearch()"
            ></el-input>
          </div>
          <div class="tab" v-if="tabshow">
            <div :class="tabstatus == 1 ? 'checked':''" @click="tabstatus = 1">组织架构</div>
            <div :class="tabstatus == 2 ? 'checked':''" @click="tabstatus = 2">角色列表</div>
            <div :class="tabstatus == 3 ? 'checked':''" @click="tabstatus = 3" v-if="Supshow">主管</div>
          </div>
          <div class="contentdiv" v-if="tabstatus == 1" :style="tabshow ? 'top: 100px':'top: 50px'">
            <div class="nav" v-if="status == 2">
              <div class="item">
                <span style="color: #6669e3; cursor: pointer;" @click="back">返回</span>
              </div>
            </div>
            <div class="nav" v-if="navname.length<4 && status == 1">
              <div class="item" v-for="(v,k) in navname" :key="k">
                <span style="cursor: pointer;" @click="onback(v,k)">{{v.label}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="nav" v-if="navname.length>=4 && status == 1">
              <div class="item">
                <span style="cursor: pointer;" @click="onback(navname[0],0)">{{navname[0].label}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="item">
                ...
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="item">
                <span
                  style="cursor: pointer;"
                  @click="onback(navname[navname.length-1],navname.length-1)"
                >{{navname[navname.length-1].label}}</span>
              </div>
            </div>
            <div class="items">
              <div style="margin-bottom: 15px;">
                <!-- 部门全选 -->
                <el-checkbox
                  v-model="checkAll"
                  :indeterminate="isIndeterminate"
                  @change="newhandleCheckAllChange"
                  v-if="ostatus == 1"
                >全选</el-checkbox>
                <!-- 员工全选 -->
                <el-checkbox
                  v-model="checkAll"
                  :indeterminate="isIndeterminate"
                  @change="neworgIdAllChange"
                  v-if="ostatus == 2"
                >全选</el-checkbox>
                <!-- 部门员工全选 -->
                <el-checkbox
                  v-model="checkAll"
                  :indeterminate="isIndeterminate"
                  @change="newAllChange"
                  v-if="ostatus == 3"
                >全选</el-checkbox>
              </div>
              <div>
                <el-checkbox-group
                  v-model="idall"
                  @change="handleCheckedCitiesChange"
                  v-if="status != 3"
                >
                  <div class="item" v-for="(v,k) in candidate" :key="k">
                    <div>
                      <span v-if="ostatus == 2" style="padding-left: 24px;">{{v.label}}</span>
                      <el-checkbox
                        :label="v.id"
                        @change="onlabels($event,v)"
                        v-if="ostatus != 2"
                        :disabled="notdepartment.indexOf(v.id) != -1"
                      >{{v.label}}</el-checkbox>
                    </div>
                    <div
                      @click="onchild(v)"
                      v-if="!onpresence(v.id) && status == 1 && notdepartment.indexOf(v.id) == -1"
                    >
                      <i class="el-icon-share"></i>下级
                    </div>
                    <div
                      style="color: #AEB1BA;"
                      v-if="(onpresence(v.id) && status == 1) || notdepartment.indexOf(v.id) != -1"
                    >
                      <i class="el-icon-share"></i>下级
                    </div>
                  </div>
                </el-checkbox-group>

                <el-checkbox-group
                  v-model="orgcheck"
                  v-if="ostatus != 1"
                  @change="handleCheckedOrgChange"
                >
                  <div class="item" v-for="(v,k) in orglist" :key="k">
                    <el-checkbox
                      :label="v.employId"
                      @change="onorglabel($event,v.employId)"
                      :disabled="notdepartment.indexOf(v.orgId) != -1"
                    >{{v.name}}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <div
            class="contentdiv treediv"
            v-if="tabstatus == 2"
            :style="tabshow ? 'top: 100px':'top: 50px'"
          >
            <el-tree
              :props="props"
              ref="tree"
              :data="rolelist"
              id="tree"
              @check="handleCheckChange"
              node-key="id"
              :default-checked-keys="ondefaultCheckedKeys()"
              show-checkbox
              :filter-node-method="filterNode"
            ></el-tree>
          </div>
          <div
            class="contentdiv supervisor"
            v-if="tabstatus == 3"
            :style="tabshow ? 'top: 100px':'top: 50px'"
          >
            <el-checkbox-group v-model="supidall">
              <div v-for="(v,k) in supervisorlist" :key="k">
                <el-checkbox
                  :label="v.id"
                  v-if="v.name.indexOf(searchval) != -1"
                  @change="onsuplabel($event,v)"
                >{{v.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <div
            class="contentdiv supervisor"
            v-if="tabstatus == 4"
            :style="tabshow ? 'top: 100px':'top: 50px'"
          >
            <el-checkbox-group v-model="admindall">
              <div v-for="(v,k) in adminList" :key="k">
                <el-checkbox
                  :label="v.employ_id"
                  v-if="v.name.indexOf(searchval) != -1"
                  @change="onsuplabels($event,v)"
                >{{v.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <div
            class="contentdiv supervisor"
            v-if="tabstatus == 5"
            :style="tabshow ? 'top: 100px':'top: 50px'"
          >
            <el-checkbox-group v-model="contract">
              <div v-for="(v,k) in contractList" :key="k">
                <el-checkbox
                  :label="v.id"
                  v-if="v.name.indexOf(searchval) != -1"
                  @change="onsupContract($event,v)"
                >{{v.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="box">
          <div v-if="tabstatus == 5">
            <div class="topTitle">
              <div>
                已选择
                <span style="color:#6669e3;font-weight:800">{{this.contracts.length}}</span> 个合同公司
              </div>
              <span>
                <span style="margin-right:15px">全部取消</span>
                <i
                  class="el-icon-error"
                  style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                  @click="alldelete"
                ></i>
              </span>
            </div>

            <div class="line"></div>
          </div>
          <div class="items">
            <div class="item" v-for="(v,k) in determined">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,1,k)"
              ></i>
            </div>

            <div class="item" v-for="(v,k) in orgdata">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,4,k)"
              ></i>
            </div>

            <div class="item" v-for="(v,k) in roleall">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,2,k)"
              ></i>
            </div>

            <div class="item" v-for="(v,k) in supall">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,3,k)"
              ></i>
            </div>
            <div class="item" v-for="(v,k) in admin">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,5,k)"
              ></i>
            </div>
            <div class="item" v-for="(v,k) in contracts">
              <span>{{v.name}}</span>
              <i
                class="el-icon-error"
                style="font-size: 18px; color: #B8B8C4; cursor: pointer;"
                @click="onnewdelete(v,6,k)"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </SsgMessagebox>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      searchval: "",
      ostatus: 1, //1组织，2员工，3部门+员工
      original: {},
      candidate: [],
      determined: [],
      idall: [],
      navname: [],
      status: 1,
      orgId: "",
      oneorgId: "",
      orglist: [],
      orgcheck: [],
      orgdata: [],
      tabstatus: 1,
      rolelist: [],
      roleall: [],
      supidall: [],
      supall: [],
      admin: [],
      admindall: [],
      contract: [],
      adminList: [],
      contractList: [],
      contracts: [],

      supervisorlist: [
        {
          id: 1,
          name: "一级主管",
        },
        {
          id: 2,
          name: "二级主管",
        },
        {
          id: 3,
          name: "三级主管",
        },
        {
          id: 4,
          name: "四级主管",
        },
        {
          id: 5,
          name: "五级主管",
        },
        {
          id: 6,
          name: "六级主管",
        },
        {
          id: 7,
          name: "七级主管",
        },
        {
          id: 8,
          name: "八级主管",
        },
      ],
      props: {
        label: "name",
        children: "children",
      },
      tabshow: true,
      Supshow: false,
      backUp: "",
    };
  },
  props: {
    titles: "",
    width: {
      default: "720px",
    },
    height: {
      default: "450px",
    },
    checkdata: {
      type: Object,
      default() {
        return {};
      },
    },

    type: {
      default() {
        return "organization";
      },
    },

    orStatus: {
      default() {
        return 1;
      },
    },

    quantity: {
      default() {
        return 0;
      },
    },

    notdepartment: {
      type: Array,
      default() {
        return [];
      },
    },

    includeChild: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  created() {
    this.backUp = JSON.stringify(this.checkdata);
    //选择角色
    if (this.type == "roles") {
      this.tabshow = false;
      this.tabstatus = 2;
      this.loadrole();
    }
    //选择主管
    if (this.type == "supervisor") {
      this.tabshow = false;
      this.tabstatus = 3;
    }
    //选择管理员
    if (this.type == "administrator") {
      this.tabshow = false;
      this.tabstatus = 4;
      this.loadManger();
    }
    //选择合同公司
    if (this.type == "contractCompany") {
      this.tabshow = false;
      this.tabstatus = 5;
      this.loadContract();
    }
    //组织架构
    if (this.type == "organization") {
      this.tabshow = false;
      this.tabstatus = 1;
      this.ostatus = this.orStatus;
      this.loadTree();
    }
    //组织，角色，主管
    if (this.type == "ro_su_or") {
      this.tabshow = true;
      this.Supshow = true;
      this.ostatus = this.orStatus;
      this.loadrole();
      this.loadTree();
    }
    //组织，角色
    if (this.type == "ro_su") {
      this.tabshow = true;
      this.ostatus = this.orStatus;
      this.loadrole();
      this.loadTree();
    }
  },

  mounted() {
    if (this.checkdata.department) {
      this.determined = this.checkdata.department;
      this.checkdata.department.forEach((v, k) => {
        this.idall.push(v.id);
      });
    }

    if (this.checkdata.employee) {
      this.orgdata = this.checkdata.employee;
      this.checkdata.employee.forEach((v, k) => {
        this.orgcheck.push(v.id);
      });
    }

    if (this.checkdata.roles) {
      this.roleall = this.checkdata.roles;
    }

    if (this.checkdata.supervisor) {
      this.supall = this.checkdata.supervisor;
      this.checkdata.supervisor.forEach((v, k) => {
        this.supidall.push(v.id);
      });
    }
    if (this.checkdata.administrator) {
      this.admin = this.checkdata.administrator;
      this.checkdata.administrator.forEach((v, k) => {
        this.admindall.push(v.employ_id);
      });
    }
    if (this.checkdata.contractCompany) {
      this.contracts = this.checkdata.contractCompany;
     
    }
  },

  methods: {
    alldelete() {
      this.contracts = [];
      this.contract = [];
    },
    //合同公司列表
    loadContract() {
      //封装请求参数
      const params = {
        name: "",
      };
      //查询列表的方法
      this.$employAxios
        .get("common/queryCompanyContractListByName", {
          params,
        })
        .then((res) => {
          let arr = []
          this.contractList = res.data.data;
          for (let j = 0; j < this.contracts.length; j++) {
            for (let i = 0; i < this.contractList.length; i++) {
              if (this.contracts[j] == this.contractList[i].id) {

                arr.push({
                  name: this.contractList[i].name,
                  id: this.contractList[i].id,
                });

                this.contract.push(this.contractList[i].id);
              }
            }
          }
          this.contracts = arr
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    loadManger() {
      //封装请求参数
      const params = {
        name: "",
      };
      //查询列表的方法
      this.$employAxios
        .get("role/queryAdminEmployList", {
          params,
        })
        .then((res) => {
          this.adminList = res.data.data.list;
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    shut() {
      this.$parent.checklist = JSON.parse(this.backUp);
      this.$parent.maskshow = false;
    },
    sub() {
      if (this.quantity) {
        var all =
          this.determined.length +
          this.orgdata.length +
          this.roleall.length +
          this.supall.length;
        if (all > this.quantity) {
          this.$message({
            message: "审批人不要超过" + this.quantity + "人",
            type: "warning",
          });
          this.shut();
          return;
        }
      }
      var obj = {};
      obj.department = this.determined; //部门
      obj.employee = this.orgdata; //员工
      obj.roles = this.roleall; //角色
      obj.supervisor = this.supall; //主管
      obj.administrator = this.admin; //管理员
      obj.contractCompany = this.contract; //合同公司列表
      this.$emit("sub", obj);
    },

    back() {
      this.searchval = "";
      this.loadTree();
    },

    loadTree() {
      //封装请求参数
      const params = {
        orgName: "",
      };
      //查询列表的方法
      this.$employAxios
        .get("employ/base/tree", {
          params,
        })
        .then((res) => {
          //数据初始化
          this.original = res.data.data[0];
          this.oneorgId = res.data.data[0].id;
          this.orgId = res.data.data[0].id;
          this.onchild(res.data.data[0]);
          this.status = 1;
          this.loadEmploye();
          // 					this.candidate = res.data.data[0].children;
          // 					var obj = {};
          // 					obj.id = res.data.data[0].id;
          // 					obj.label = res.data.data[0].label;
          // 					this.navname.push(obj);
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    loadrole() {
      this.$employAxios
        .get("role/roleTabletree")
        .then((res) => {
          if (res.data.status == 1) {
            this.rolelist = res.data.data;
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    loadEmploye() {
      if (this.ostatus != 1) {
        const params = {
          orgIds: this.orgId,
          type: 1,
        };
        //查询列表的方法
        this.$employAxios
          .get("employ/base/findEmployByOrg", {
            params,
          })
          .then((res) => {
            if (res.data.status == 1) {
              this.orglist = res.data.data;
              this.handleCheckedOrgChange(this.orgcheck);
            }
          })
          .catch((err) => {
            //处理错误
            console.error(err);
          });
      }
    },

    searchfindEmployee() {
      const params = {
        orgId: this.oneorgId,
        ids: "",
        bs: 1,
        type: 1,
        pageNum: 0,
        pageSize: 0,
        name: "",
        total: "",
        state: "",
        startDate: "",
        becomeDate: "",
        positionLevel: "",
        employeeInfo: this.searchval,
      };
      //查询列表的方法
      return this.$employAxios
        .get("employee/findEmployee", {
          params,
        })
        .then((res) => {
          //数据初始化
          if (res.data.status == 1) {
            var list = [];
            res.data.data.list.forEach((v, k) => {
              v.employId = v.employ_id;
            });
            this.orglist = res.data.data.list;
            if (this.ostatus == 2) {
              this.status = 3;
            } else {
              this.status = 2;
            }
            this.handleCheckedOrgChange(this.orgcheck);
          }
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },

    searchorgName() {
      this.$employAxios
        .get("/org/search?orgName=" + this.searchval)
        .then((res) => {
          if (res.data.status == 1) {
            this.candidate = res.data.data;
            this.handleCheckedCitiesChange(this.idall);
          }
        });
    },

    onchild(val) {
      this.orgId = val.id;
      this.loadEmploye();
      this.candidate = val.children;
      this.navname.push(val);
      this.handleCheckedCitiesChange(this.idall);
    },

    onnewdelete(val, status, key) {
      if (status == "1") {
        if (this.includeChild) {
          this.ondelete(val);
        } else {
          this.determined.splice(key, 1);
          if (this.idall.indexOf(val.id) != -1) {
            this.idall.splice(this.idall.indexOf(val.id), 1);
          }
          this.handleCheckedCitiesChange(this.idall);
        }
      } else if (status == "4") {
        this.orgdata.splice(key, 1);
        if (this.orgcheck.indexOf(val.id) != -1) {
          this.orgcheck.splice(this.orgcheck.indexOf(val.id), 1);
        }
        this.handleCheckedOrgChange(this.orgcheck);
      } else if (status == "2") {
        this.roleall.splice(key, 1);
        this.$refs.tree.setCheckedKeys([key]);
      } else if (status == "3") {
        this.supall.splice(key, 1);
        if (this.supidall.indexOf(val.id) != -1) {
          this.supidall.splice(this.supidall.indexOf(val.id), 1);
        }
      } else if (status == "5") {
        this.admin.splice(key, 1);
        if (this.admindall.indexOf(val.employ_id) != -1) {
          this.admindall.splice(this.admindall.indexOf(val.employ_id), 1);
        }
      } else if (status == "6") {
        this.contracts.splice(key, 1);
        if (this.contract.indexOf(val.id) != -1) {
          this.contract.splice(this.contract.indexOf(val.id), 1);
        }
      }
    },

    async ondelete(val) {
      var res = await this.$employAxios.get(
        "/employ/base/getOrgList?orgId=" + val.id
      );
      if (res.data.status != 1) {
        this.$message.error("部门id查询失败");
        return;
      }
      var arr = res.data.data.split(",");

      arr.forEach((v, k) => {
        if (this.idall.indexOf(v) != -1) {
          this.idall.splice(this.idall.indexOf(v), 1);
        }
        this.determined.forEach((x, y) => {
          if (x.id == v) {
            this.determined.splice(y, 1);
          }
        });
      });
      this.handleCheckedCitiesChange(this.idall);
    },

    onpresence(id) {
      for (var i = 0; i < this.determined.length; i++) {
        if (this.determined[i].id == id) {
          return true;
        }
      }
      return false;
    },

    onback(val, k) {
      this.navname.splice(k, this.navname.length - k);
      this.onchild(val);
    },

    onsearch() {
      if (this.tabstatus == 1) {
        this.navname = [];
        if (this.searchval) {
          //人员
          if (this.ostatus != 1) {
            this.searchfindEmployee();
          }
          //部门
          if (this.ostatus != 2) {
            this.searchorgName();
          }
        } else {
          this.loadTree();
        }
      } else if (this.tabstatus == 2) {
        this.$refs.tree.filter(this.searchval);
      }
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    handleCheckedCitiesChange(value) {
      if (this.ostatus != 3) {
        if (this.candidate) {
          var checkedCount = 0;
          value.forEach((v, k) => {
            this.candidate.forEach((x, y) => {
              if (x.id == v) {
                checkedCount++;
              }
            });
          });
          this.checkAll =
            checkedCount === this.candidate.length && checkedCount != 0;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.candidate.length;
        }
      } else {
        this.handleCheckedAllChange();
      }
    },

    handleCheckedOrgChange(value, boot) {
      if (this.ostatus != 3) {
        if (this.orglist) {
          var checkedCount = 0;
          value.forEach((v, k) => {
            this.orglist.forEach((x, y) => {
              if (x.employId == v) {
                checkedCount++;
              }
            });
          });
          this.checkAll =
            checkedCount === this.orglist.length && checkedCount != 0;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.orglist.length;
        }
      } else {
        this.handleCheckedAllChange();
      }
    },

    handleCheckedAllChange() {
      if (!this.orglist) {
        this.orglist = [];
      }

      if (!this.candidate) {
        this.candidate = [];
      }
      var checkedCount = 0;
      var allCount = this.orglist.length + this.candidate.length;

      this.orgcheck.forEach((v, k) => {
        this.orglist.forEach((x, y) => {
          if (x.employId == v) {
            checkedCount++;
          }
        });
      });

      this.idall.forEach((v, k) => {
        this.candidate.forEach((x, y) => {
          if (x.id == v) {
            checkedCount++;
          }
        });
      });

      this.checkAll = checkedCount === allCount && checkedCount != 0;
      this.isIndeterminate = checkedCount > 0 && checkedCount < allCount;
    },

    newhandleCheckAllChange(val) {
      if (val) {
        this.candidate.forEach((v, k) => {
          if (this.includeChild) {
            var arr = this.getCurrentPart(v);
            arr.forEach((x, y) => {
              if (this.idall.indexOf(x.id) == -1) {
                if (this.notdepartment.indexOf(x.id) == -1) {
                  this.idall.push(x.id);
                  this.determined.push({
                    id: x.id,
                    name: x.label,
                  });
                }
              }
            });
          } else {
            if (this.idall.indexOf(v.id) == -1) {
              if (this.notdepartment.indexOf(v.id) == -1) {
                this.idall.push(v.id);
                this.determined.push({
                  id: v.id,
                  name: v.label,
                });
              }
            }
          }
        });
      } else {
        this.idall = [];
        this.determined = [];
      }
      this.isIndeterminate = false;
    },

    neworgIdAllChange(val) {
      if (val) {
        this.orglist.forEach((v, k) => {
          if (this.orgcheck.indexOf(v.employId) == -1) {
            if (this.notdepartment.indexOf(v.orgId) == -1) {
              this.orgcheck.push(v.employId);
              this.orgdata.push({
                id: v.employId,
                name: v.name,
                // value: v,
              });
            }
          }
        });
      } else {
        this.orgcheck = [];
        this.orgdata = [];
      }
      this.isIndeterminate = false;
    },

    newAllChange(val) {
      this.newhandleCheckAllChange(val);
      this.neworgIdAllChange(val);
    },

    handleCheckAllChange(val) {
      if (val) {
        return;
        this.candidate.forEach((v, k) => {
          var arr = this.getCurrentPart(v);
          arr.forEach((x, y) => {
            if (this.idall.indexOf(x.id) == -1) {
              this.idall.push(x.id);
            }
            if (this.determined.length != 0) {
              for (var i = 0; i < this.determined.length; i++) {
                if (this.determined[i].id == x.id) {
                  return;
                }
              }
            }
            this.determined.push({
              id: x.id,
              label: x.label,
            });
          });
        });
      } else {
        this.candidate.forEach((v, k) => {
          var arr = this.getCurrentPart(v);
          arr.forEach((x, y) => {
            if (this.idall.indexOf(x.id) != -1) {
              this.idall.splice(this.idall.indexOf(x.id), 1);
            }
            this.determined.forEach((i, j) => {
              if (x.id == i.id) {
                this.determined.splice(j, 1);
              }
            });
          });
        });
      }
      this.isIndeterminate = false;
    },

    onnewlabel(boolean, id) {
      if (boolean) {
        this.candidate.forEach((v, k) => {
          if (v.id == id) {
            this.determined.push({
              id: v.id,
              name: v.label,
            });
          }
        });
      } else {
        this.determined.forEach((v, k) => {
          if (v.id == id) {
            this.determined.splice(k, 1);
          }
        });
      }
    },

    onorglabel(boolean, id) {
      if (boolean) {
        this.orglist.forEach((v, k) => {
          if (v.employId == id) {
            this.orgdata.push({
              id: v.employId,
              name: v.name,
              // value: v,
            });
          }
        });
      } else {
        this.orgdata.forEach((v, k) => {
          if (v.id == id) {
            this.orgdata.splice(k, 1);
          }
        });
      }
    },

    onsuplabel(boolean, val) {
      if (boolean) {
        this.supall.push(val);
      } else {
        this.supall.forEach((v, k) => {

          if (v.id == val.id) {
            this.supall.splice(k, 1);
          }
        });
      }
    },
    onsuplabels(boolean, val) {
      if (boolean) {
        this.admin.push(val);
      } else {
        this.admin.forEach((v, k) => {
          if (v.employ_id == val.employ_id) {
            this.admin.splice(k, 1);
          }
        });
      }
    },
    onsupContract(boolean, val) {
      if (boolean) {
        this.contracts.push(val);
      } else {
        [...this.contracts.forEach((v, k) => {
          if (v.id == val.id) {
            this.contracts.splice(k, 1);
          }
        })]
        
      }
    },

    onlabels(boolean, val) {
      if (this.includeChild) {
        this.onlabel(boolean, val);
      } else {
        this.onnewlabel(boolean, val.id);
      }
    },

    onlabel(boolean, val) {
      var arr = this.getCurrentPart(val);
      if (boolean) {
        arr.forEach((v, k) => {
          if (this.idall.indexOf(v.id) == -1) {
            this.idall.push(v.id);
          }

          if (this.determined.length != 0) {
            for (var i = 0; i < this.determined.length; i++) {
              if (this.determined[i].id == v.id) {
                return;
              }
            }
          }
          this.determined.push({
            id: v.id,
            name: v.label,
          });
        });
      } else {
        arr.forEach((v, k) => {
          if (this.idall.indexOf(v.id) != -1) {
            this.idall.splice(this.idall.indexOf(v.id), 1);
          }

          this.determined.forEach((x, y) => {
            if (x.id == v.id) {
              this.determined.splice(y, 1);
            }
          });
        });
      }
    },

    getCurrentPart(val) {
      var arr = [];
      var obj = {};
      obj.id = val.id;
      obj.label = val.label;
      arr.push(obj);
      if (val.children) {
        val.children.forEach((v, k) => {
          arr = arr.concat(this.getCurrentPart(v));
        });
      }
      return arr;
    },

    handleCheckChange(data) {
      if (this.roleall.length > 0) {
        for (var i = 0; i < this.roleall.length; i++) {
          if (this.roleall[i].id == data.id) {
            this.roleall.splice(i, 1);
            return;
          }
        }
        this.roleall.push({
          id: data.id,
          name: data.name,
        });
      } else {
        this.roleall.push({
          id: data.id,
          name: data.name,
        });
      }
    },

    ondefaultCheckedKeys() {
      var arr = [];
      if (this.roleall.length > 0) {
        this.roleall.forEach((v, k) => {
          if (v.value) {
            arr.push(v.value);
          } else {
            arr.push(v.id);
          }
        });
      }

      return arr;
    },
  },
};
</script>

<style scoped lang="less">
.period /deep/ .messagebox .title {
  border-bottom: none;
}

.period /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
}

.period /deep/ .el-input__icon {
  line-height: 30px;
}

.period /deep/ #mask {
  z-index: 3000;
}

.boxs {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
  box-sizing: border-box;

  .box {
    width: 50%;
    height: 100%;
    background-color: #f2f5f8;
    margin: 0 6px;
    border: 1px solid #d9dbe2;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    .topTitle {
      display: flex;
      justify-content: space-between;
      margin: 5px 0 16px 0;
      font-size: 12px;
      font-weight: 400;
      color: rgba(48, 49, 64, 1);
    }
    .line {
      height: 1px;
      width: 100%;
      background-color: #d9dbe2;
      margin-bottom: 17px;
    }
    .tab {
      width: 100%;
      min-height: 36px;
      display: flex;
      background: #e7eaef;
      margin: 10px 0;
      border-radius: 4px;
      display: flex;
      overflow: hidden;

      div {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
      }

      .checked {
        background: #6669e3;
        color: #fff;
      }
    }

    .contentdiv {
      width: 100%;
      position: absolute;
      left: 0px;
      right: 0px;
      bottom: 0px;
      overflow: auto;
      padding: 0 16px;
    }

    .treediv {
      overflow: auto;
    }

    .supervisor {
      width: 100%;
      overflow: auto;

      div {
        margin-bottom: 15px;
      }
    }

    .nav {
      width: 100%;
      margin: 10px 0;
      display: flex;
      align-items: center;

      .item {
        font-size: 14px;

        span {
          color: #6669e3;
        }

        i {
          padding: 0 5px;
        }
      }

      .item:last-child {
        span {
          color: #545566;
        }

        i {
          display: none;
        }
      }
    }

    .items {
      width: 100%;
      // height: 100%;
      // overflow: auto;

      .item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        align-items: center;
        font-size: 14px;

        div {
          display: flex;
          align-items: center;

          input {
            margin-right: 5px;
          }
        }

        div:last-child {
          color: #6069f2;
          cursor: pointer;

          i {
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.el-tree {
  background: #f2f5f8;
}
</style>
